/* ============================================================
   MTi USA — Registration v2
   Form behavior: phone formatter, role chips, same-as-above,
   client validation, hidden password generation, note JSON encoding.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('form.mti-reg-v2__form').forEach(initForm);
  });

  function initForm(form) {
    setupPhoneFormatting(form);
    setupRoleChips(form);
    setupConsents(form);
    setupStepper(form);
    form.addEventListener('submit', handleSubmit);
  }

  /* ---------- Section progress stepper ---------- */
  function setupStepper(form) {
    var nav = form.querySelector('[data-mti-stepper]');
    if (!nav) return;
    var steps = Array.prototype.slice.call(nav.querySelectorAll('.mti-reg-v2__step'));
    var sections = Array.prototype.slice.call(form.querySelectorAll('[data-mti-section]'))
      .sort(function (a, b) {
        return parseInt(a.getAttribute('data-mti-section'), 10) - parseInt(b.getAttribute('data-mti-section'), 10);
      });
    if (!steps.length || !sections.length) return;

    // Click to scroll
    nav.querySelectorAll('[data-mti-step-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var el = document.getElementById(btn.getAttribute('data-mti-step-target'));
        if (!el) return;
        var stepperOffset = nav.getBoundingClientRect().height + 16;
        var top = el.getBoundingClientRect().top + window.pageYOffset - stepperOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    if (!('IntersectionObserver' in window)) {
      setActive(0);
      return;
    }

    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.getAttribute('data-mti-section')] = entry.isIntersecting;
      });
      var firstVisible = -1;
      for (var i = 0; i < sections.length; i++) {
        if (visible[String(i)]) { firstVisible = i; break; }
      }
      if (firstVisible !== -1) setActive(firstVisible);
    }, { rootMargin: '-120px 0px -55% 0px', threshold: 0 });

    sections.forEach(function (s) { observer.observe(s); });
    setActive(0);

    function setActive(idx) {
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === idx);
        step.classList.toggle('is-complete', i < idx);
      });
    }
  }

  /* ---------- Phone live formatting ---------- */
  function setupPhoneFormatting(form) {
    var phone = form.querySelector('[data-mti-phone]');
    if (!phone) return;
    phone.addEventListener('input', function () {
      var d = (phone.value || '').replace(/\D/g, '').slice(0, 10);
      var v = d;
      if (d.length >= 7) v = '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
      else if (d.length >= 4) v = '(' + d.slice(0, 3) + ') ' + d.slice(3);
      else if (d.length > 0) v = d;
      phone.value = v;
      clearFieldError(phone);
    });
  }

  /* ---------- Role chip selector ---------- */
  function setupRoleChips(form) {
    var chips = form.querySelectorAll('[data-mti-role-chip]');
    var hidden = form.querySelector('[data-mti-role-value]');
    var otherWrap = form.querySelector('[data-mti-role-other-wrap]');
    var otherInput = form.querySelector('[data-mti-role-other]');
    if (!chips.length || !hidden) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        var value = chip.getAttribute('data-mti-role-chip');
        hidden.value = value;
        var wrap = form.querySelector('[data-mti-role-wrap]');
        if (wrap) wrap.classList.remove('is-invalid');
        if (otherWrap) {
          if (value === 'other') {
            otherWrap.hidden = false;
            if (otherInput) setTimeout(function () { otherInput.focus(); }, 50);
          } else {
            otherWrap.hidden = true;
            otherWrap.classList.remove('is-invalid');
            if (otherInput) otherInput.value = '';
          }
        }
      });
    });
    if (otherInput) {
      otherInput.addEventListener('input', function () {
        if (otherWrap) otherWrap.classList.remove('is-invalid');
      });
    }
  }

  /* ---------- "Same as above" copy ---------- */
  // Without duplicate fields the button is unused, but keep this hook for future variants.
  function setupSameAsAbove(form, srcSel, dstSel) {
    var btn = form.querySelector('[data-mti-same-as-above]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var first = form.querySelector(srcSel);
      var last = form.querySelector(dstSel);
      var primFirst = form.querySelector('[name="company_first_name"]');
      var primLast = form.querySelector('[name="company_last_name"]');
      if (first && primFirst) primFirst.value = first.value;
      if (last && primLast) primLast.value = last.value;
    });
  }

  /* ---------- Consent box invalidation reset ---------- */
  function setupConsents(form) {
    form.querySelectorAll('[data-mti-check]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var wrap = cb.closest('.mti-reg-v2__check-wrap');
        if (wrap && cb.checked) wrap.classList.remove('is-invalid');
      });
    });
    form.querySelectorAll('.mti-reg-v2__input, .mti-reg-v2__select').forEach(function (el) {
      el.addEventListener('input', function () { clearFieldError(el); });
      el.addEventListener('change', function () { clearFieldError(el); });
    });
  }

  function clearFieldError(el) {
    var f = el.closest('.mti-reg-v2__field');
    if (f) f.classList.remove('is-invalid');
  }
  function setFieldError(el, msg) {
    var f = el.closest('.mti-reg-v2__field');
    if (!f) return;
    f.classList.add('is-invalid');
    var err = f.querySelector('[data-mti-error]');
    if (err && msg) err.textContent = msg;
  }
  function setCheckError(form, name) {
    var cb = form.querySelector('[data-mti-check][name="' + name + '"]');
    if (!cb) return;
    var wrap = cb.closest('.mti-reg-v2__check-wrap');
    if (wrap) wrap.classList.add('is-invalid');
  }

  /* ---------- Validation + submit ---------- */
  function handleSubmit(e) {
    var form = e.currentTarget;
    var errors = validate(form);
    if (errors.length > 0) {
      e.preventDefault();
      errors.forEach(function (err) {
        if (err.type === 'check') setCheckError(form, err.name);
        else setFieldError(err.el, err.msg);
      });
      var first = form.querySelector('.is-invalid');
      if (first && first.scrollIntoView) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = first.querySelector('input, select, textarea, button');
        if (input && input.focus) setTimeout(function () { input.focus({ preventScroll: true }); }, 320);
      }
      return;
    }
    // Encode extras into customer[note] before letting the form post.
    encodeExtras(form);
    // Ensure password fields have a strong random value.
    fillRandomPassword(form);
    // Lock UI
    var btn = form.querySelector('[data-mti-submit]');
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
      var label = btn.querySelector('[data-mti-submit-label]');
      if (label) label.textContent = 'Creating your account…';
    }
  }

  function validate(form) {
    var errs = [];
    function require(name, msg) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return;
      if (!el.value || !el.value.trim()) errs.push({ el: el, msg: msg });
    }
    require('customer[first_name]', 'First name required.');
    require('customer[last_name]',  'Last name required.');

    var email = form.querySelector('[name="customer[email]"]');
    if (!email || !email.value.trim()) {
      if (email) errs.push({ el: email, msg: 'Email required.' });
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      errs.push({ el: email, msg: 'That email looks off.' });
    }

    var phone = form.querySelector('[name="customer[phone]"]');
    if (!phone || !phone.value.trim()) {
      if (phone) errs.push({ el: phone, msg: 'Phone required so a rep can verify your account.' });
    } else if (phone.value.replace(/\D/g, '').length < 10) {
      errs.push({ el: phone, msg: 'Need 10 digits.' });
    }

    require('company_name',   'Company name required.');
    require('address1',       'Street address required.');
    require('city',           'City required.');
    require('state',          'Pick your state / region.');
    require('zip',            'ZIP / postal code required.');

    var role = form.querySelector('[data-mti-role-value]');
    if (!role || !role.value) {
      var wrap = form.querySelector('[data-mti-role-wrap]');
      if (wrap) wrap.classList.add('is-invalid');
      errs.push({ type: 'role-stub' });
    } else if (role.value === 'other') {
      var otherInput = form.querySelector('[data-mti-role-other]');
      var otherWrap = form.querySelector('[data-mti-role-other-wrap]');
      if (!otherInput || !otherInput.value.trim()) {
        if (otherWrap) otherWrap.classList.add('is-invalid');
        errs.push({ type: 'role-other-stub' });
      }
    }
    require('site_type', 'Pick your site type.');

    var agree = form.querySelector('[data-mti-check][name="agree_terms"]');
    if (!agree || !agree.checked) errs.push({ type: 'check', name: 'agree_terms' });

    return errs;
  }

  /* ---------- Encode extra fields into customer[note] + tags ---------- */
  function encodeExtras(form) {
    var get = function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return '';
      if (el.type === 'checkbox') return !!el.checked;
      return (el.value || '').trim();
    };
    var phone = get('customer[phone]');
    var phoneE164 = phone ? '+1' + phone.replace(/\D/g, '') : '';
    var role = (form.querySelector('[data-mti-role-value]') || {}).value || '';

    var data = {
      v: 1,
      submitted_at: new Date().toISOString(),
      company: {
        name: get('company_name'),
        address1: get('address1'),
        address2: get('address2'),
        city: get('city'),
        state: get('state'),
        country: get('country'),
        zip: get('zip')
      },
      operation: {
        role: role,
        role_other: role === 'other' ? get('role_other') : '',
        site_type: get('site_type'),
        hear: get('hear')
      },
      consents: {
        terms: get('agree_terms'),
        sms: get('sms_opt_in'),
        newsletter: get('customer[accepts_marketing]')
      },
      contact: {
        phone_display: phone,
        phone_e164: phoneE164
      }
    };

    var noteEl = form.querySelector('[name="customer[note]"]');
    if (noteEl) noteEl.value = JSON.stringify(data);

    // Tags: keep parseable, lowercase, no spaces. Flow can trigger off pending-b2b-setup.
    var slug = function (s) {
      return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
    };
    var tagsEl = form.querySelector('[name="customer[tags]"]');
    if (tagsEl) {
      var tags = [];
      var base = (tagsEl.getAttribute('data-mti-base-tags') || '').split(',');
      base.forEach(function (t) { var v = (t || '').trim(); if (v) tags.push(v); });
      tags.push('pending-b2b-setup');
      if (data.operation.site_type) tags.push('site-type:' + slug(data.operation.site_type));
      if (data.operation.role) tags.push('role:' + slug(data.operation.role));
      if (data.company.name) tags.push('company:' + slug(data.company.name));
      tagsEl.value = tags.join(', ');
    }
  }

  /* ---------- Random password (user never sees or types it) ---------- */
  function fillRandomPassword(form) {
    var pw = form.querySelector('[name="customer[password]"]');
    var pc = form.querySelector('[name="customer[password_confirmation]"]');
    if (!pw && !pc) return;
    var bytes = new Uint8Array(24);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    var alpha = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%^&*';
    var out = '';
    for (var i = 0; i < bytes.length; i++) out += alpha[bytes[i] % alpha.length];
    if (pw) pw.value = out;
    if (pc) pc.value = out;
  }
})();
